import { useMemo } from 'react';
import useApi from './useApi';
import { getMaintenanceModeState } from '../utils/maintenanceMode';

export const useMaintenanceMode = () => {
  const API = useApi({});
  const publisherMetaData = API.getPublisherMeta.data;

  return useMemo(
    () => getMaintenanceModeState(publisherMetaData),
    [publisherMetaData]
  );
};
